import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const FIELD = "h-10 border-slate-800 bg-slate-900/70 text-slate-100";

function F({ label, testId, value, onChange, error, errorId = "client-name-error", placeholder, type = "text", className = "" }) {
  return (
    <div className={`space-y-1.5 ${className}`}>
      <Label className="text-[11px] uppercase tracking-wider text-slate-400">{label}</Label>
      <Input data-testid={testId} type={type} value={value ?? ""} placeholder={placeholder} onChange={(e) => onChange(e.target.value)}
        className={`${FIELD} ${error ? "border-red-500/70" : ""} ${type === "number" ? "font-mono-num" : ""}`} />
      {error && <p data-testid={errorId} className="text-xs text-red-400">{error}</p>}
    </div>
  );
}

export function QuoteDetails({ q, set, clientError }) {
  return (
    <div className="grid gap-4 rounded-2xl border border-slate-800 bg-[#F2F2F7]/60 p-5 md:grid-cols-3" data-testid="quote-details-card">
      <F label="Customer *" testId="quote-client-name-input" value={q.client_name} onChange={(v) => set({ client_name: v })} error={clientError} placeholder="e.g. Smith" />
      <F label="Quote / project name" testId="quote-project-name-input" value={q.project_name} onChange={(v) => set({ project_name: v })} placeholder="e.g. Lake House" />
      <F label="Project site" testId="quote-project-site-input" value={q.project_site} onChange={(v) => set({ project_site: v })} placeholder="Address" />
      <F label="PO number" testId="quote-po-number-input" value={q.po_number} onChange={(v) => set({ po_number: v })} />
      <F label="Payment terms" testId="quote-payment-terms-input" value={q.payment_terms} onChange={(v) => set({ payment_terms: v })} />
      <F label="Est. delivery" testId="quote-est-delivery-input" value={q.est_delivery} onChange={(v) => set({ est_delivery: v })} placeholder="e.g. 6–8 weeks" />
    </div>
  );
}

export function QuoteCharges({ q, set }) {
  const n = (v) => (v === "" || v === null || v === undefined ? 0 : Number(v));
  const shipErr = !(n(q.shipping) >= 0) ? "Must be 0 or more" : "";
  const taxErr = !(n(q.tax_rate) >= 0 && n(q.tax_rate) <= 100) ? "Must be between 0 and 100" : "";
  return (
    <div className="grid gap-4 rounded-2xl border border-slate-800 bg-[#F2F2F7]/60 p-5 md:grid-cols-[1.4fr_1fr_1fr_0.8fr]" data-testid="quote-charges-card">
      <F label="Upgrade / discount label" testId="quote-upgrade-label-input" value={q.upgrade_label} onChange={(v) => set({ upgrade_label: v })} placeholder="e.g. Upgrade to Element Line" />
      <F label="Upgrade amount ($, negative = discount)" testId="quote-upgrade-amount-input" type="number" value={q.upgrade_amount} onChange={(v) => set({ upgrade_amount: v })} />
      <F label="Shipping & delivery ($)" testId="quote-shipping-input" type="number" value={q.shipping} onChange={(v) => set({ shipping: v })} error={shipErr} errorId="quote-shipping-error" />
      <F label="Tax rate (%)" testId="quote-tax-rate-input" type="number" value={q.tax_rate} onChange={(v) => set({ tax_rate: v })} error={taxErr} errorId="quote-tax-rate-error" />
      <div className="space-y-1.5 md:col-span-4">
        <Label className="text-[11px] uppercase tracking-wider text-slate-400">Notes (shown on the estimate)</Label>
        <Textarea data-testid="quote-notes-input" value={q.notes || ""} onChange={(e) => set({ notes: e.target.value })} rows={3}
          className="border-slate-800 bg-slate-900/70 text-slate-100" />
      </div>
    </div>
  );
}
